/* unplugin-vue-components disabled */import { render } from "./myBookCase.vue?vue&type=template&id=50bc590d&scoped=true&ts=true"
import script from "./myBookCase.vue?vue&type=script&lang=ts"
export * from "./myBookCase.vue?vue&type=script&lang=ts"

import "./myBookCase.vue?vue&type=style&index=0&id=50bc590d&scoped=true&lang=scss"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bc590d"]])

export default __exports__